import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function BundleContents() {
  const items = ['Las 100 preguntas oficiales del USCIS organizadas por bloques temáticos con su traducción exacta al español', 'Simulación completa de entrevista con preguntas personales del formulario N-400 y preguntas de historia y gobierno', 'Guía rápida de preguntas difíciles con las respuestas exactas que el oficial espera escuchar', 'Resumen visual de temas clave para repasar en minutos antes de entrar a tu entrevista', 'Mini plantilla de autoprueba semanal para medir tu avance y saber exactamente en qué necesitas practicar más', 'Vista previa de frases clave en inglés para que empieces a sentirte cómodo respondiendo en el idioma de la entrevista'];
  return <section className="w-full bg-[#F7F5F0]" data-id="element-62">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-24" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-64">
          <div className="text-center mb-12" data-id="element-65">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#1B2A4A] mb-4" data-id="element-66">
              Presentando: Ciudadanía USA Guía Exprés 2026
            </h2>
            <p className="text-xl text-gray-700" data-id="element-67">
              El único sistema bilingüe de preparación para la entrevista de
              ciudadanía diseñado específicamente para hispanohablantes.
            </p>
          </div>

          <div className="bg-white p-8 sm:p-10 rounded-2xl shadow-lg border-t-4 border-[#C9A84C]" data-id="element-68">
            <h3 className="text-2xl font-bold text-[#1B2A4A] mb-8 text-center" data-id="element-69">
              Dentro encontrarás:
            </h3>
            <ul className="space-y-6" data-id="element-70">
              {items.map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-71">
                  <CheckCircleIcon className="w-6 h-6 text-[#C9A84C] flex-shrink-0 mt-1" data-id="element-72" />
                  <span className="text-lg text-gray-700 leading-relaxed" data-id="element-73">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}